<template>
  <div class="instruct-wrapper">
    <div class="instuctor-process-options">
      <WidgetToolbar title="Communications" :icon="require('@/assets/admin-icon/menu/communication-active.svg')">
        <div class="options row">
          <widgetDropdown v-if="false" v-model="show_switch_page_dropdown" :right="true" :hover="false"
            :interactive="true">
            <button class="btn-dropdown">
              <span>Meritios Mail</span>
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in mail_pages" :key="index"
                @click="switchMailPage(item)">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 20px"></div>
          <widgetButton @click="newAddEmail()" class="btn-secondary">
            Compose
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="instruct-widget">
      <div class="tab-widget">
        <div class="tab-header">
          <CommunicationsProcessMenus @selected="onSelectedEmailProcess"></CommunicationsProcessMenus>
        </div>
        <div class="tabs-body">
          <EmailTemplatePanel @onUseTemplate="onUseTemplate" @onAddTemplate="showAddTemplateModal"
            @onUpdateTemplate="showUpdateTemplateModal" :phase="active_email_process"></EmailTemplatePanel>

          <DraftEmailPanel v-if="active_panel_section_tab == 1" :phase="active_email_process"
            @updateEmail="showUpdateEmailFormModal" @switchTab="switchEmailTab"></DraftEmailPanel>
          <SentEmailPanel v-if="active_panel_section_tab == 2" :phase="active_email_process"
            @switchTab="switchEmailTab">
          </SentEmailPanel>
          <SignaturePanel v-if="active_panel_section_tab == 3" :phase="active_email_process"
            @updateSignature="showUpdateSignatureFormModal" @addSignature="showAddSignatureFormModal"
            @switchTab="switchEmailTab"></SignaturePanel>


        </div>
      </div>
    </div>

    <!-- Create Message&Email Modal -->
    <composeNewEmail v-if="show_email_modal" :value="selected_item_details" :template="email_template_tmp"
      :phase="active_email_process" @saved="emailSaved" @emailSent="onEmailSent" @close="show_email_modal = false">
    </composeNewEmail>

    <!-- Create Email Signature modal  -->
    <addNewSignature v-if="show_signature_modal" :value="selected_item_details" @saved="signatureSaved()"
      @close="show_signature_modal = false">
    </addNewSignature>

    <!-- New Template Modal -->
    <NewTemplateModal v-if="show_new_template_modal" :saveAs="saveAsTemplateIsActive" :value="email_template_tmp"
      :phase="active_email_process" @saved="templateSaved()" @close="show_new_template_modal = false">
    </NewTemplateModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";

import CommunicationsProcessMenus from "./components/CommunicationsProcessMenus.vue";

import composeNewEmail from "./components/composeNewEmail.vue";
import addNewSignature from "./components/addNewSignature.vue";

import EmailTemplatePanel from "./panels/EmailTemplatePanel.vue";
import NewTemplateModal from "./components/newTemplateModal.vue"

import DraftEmailPanel from "./panels/DraftEmailPanel.vue";
import SentEmailPanel from "./panels/SentEmailPanel.vue";
import SignaturePanel from "./panels/SignaturePanel.vue";


export default {
  name: "LiaProcessEmail",
  components: {
    composeNewEmail,
    addNewSignature,
    CommunicationsProcessMenus,
    EmailTemplatePanel,
    DraftEmailPanel,
    SentEmailPanel,
    SignaturePanel,
    NewTemplateModal
  },
  props: {},
  data: () => {
    return {
      loading_page_data: true,
      selected_item_details: null,
      active_panel_section_tab: 2,
      // Draft valiables
      show_email_modal: false,
      // Signature valiables
      show_signature_modal: false,
      signatures: [],
      active_email_process: "prior-lia",
      show_new_template_modal: false,
      email_template_tmp: null,
      saveAsTemplateIsActive: false,
      show_switch_page_dropdown: false,
      mail_pages: [
        { name: "Other Mail", value: "other_email" },
        { name: "Meritios Mail", value: "meritios_email" }
      ]
    };
  },
  mounted() {
  },
  computed: {},
  watch: {},
  methods: {
    switchMailPage(item) {
      let vm = this;
      vm.$emit("switchPage", item.value);
    },
    onSelectedEmailProcess(name) {
      let vm = this;
      vm.active_email_process = name;
      setTimeout(() => {
        vm.switchEmailTab(2);
        eventBus.$emit("sentEmailReflesh");
        eventBus.$emit("draftEmailReflesh");
        eventBus.$emit("EmailTemplateReflesh");
      }, 100);

    },
    switchEmailTab(number) {
      let vm = this;
      vm.active_panel_section_tab = number;
    },
    //Email Signature
    showAddSignatureFormModal() {
      let vm = this;
      vm.selected_item_details = null;
      vm.show_signature_modal = true;
    },
    showUpdateSignatureFormModal(item) {
      let vm = this;
      vm.selected_item_details = item;
      vm.show_signature_modal = true;
    },
    signatureSaved() {
      let vm = this;
      vm.show_signature_modal = false;
      eventBus.$emit("signatureReflesh");
    },
    // Email Template
    onUseTemplate(item) {
      let vm = this;
      vm.selected_item_details = null;
      vm.email_template_tmp = item;
      vm.show_email_modal = true;
    },
    showUpdateTemplateModal(item) {
      let vm = this;
      vm.selected_item_details = null;
      vm.email_template_tmp = item;
      vm.saveAsTemplateIsActive = false;
      vm.show_new_template_modal = true;
    },
    showAddTemplateModal() {
      let vm = this;
      vm.selected_item_details = null;
      vm.email_template_tmp = null;
      vm.saveAsTemplateIsActive = false;
      vm.show_new_template_modal = true;
    },
    // Email
    onEmailSent(data) {
      let vm = this;
      vm.show_email_modal = false;
      eventBus.$emit("draftEmailReflesh");
      eventBus.$emit("sentEmailReflesh");
      if (!vm.selected_item_details && !vm.vm.email_template_tmp) {
        eventBus.$emit("openDialogMessage", {
          title: "New template",
          message: "Would you consider saving this email as a template for future use? This way, you can easily reference and reuse the content without having to recreate it each time.",
          action_label: "Yes, save as template",
          action_path: null,
          action_close_label: "Don’t save",
          callback: () => {
            vm.email_template_tmp = data;
            vm.saveAsTemplateIsActive = true;
            vm.show_new_template_modal = true;
          },
        });
      }
    },
    emailSaved(data) {
      let vm = this;
      vm.show_email_modal = false;
      eventBus.$emit("draftEmailReflesh");
    },
    showUpdateEmailFormModal(item) {
      let vm = this;
      vm.selected_item_details = item;
      vm.show_email_modal = true;
    },
    newAddEmail() {
      let vm = this;
      vm.selected_item_details = null;
      vm.email_template_tmp = null;
      vm.show_email_modal = true;
    },

    // Template
    templateSaved() {
      let vm = this;
      vm.show_new_template_modal = false;
      eventBus.$emit("EmailTemplateReflesh");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .instuctor-process-options {
    position: absolute;
    top: 5px;
    right: 5px;
    left: 5px;
  }

  .instruct-widget {
    height: 100%;
    display: flex;
    flex-direction: column;

    .tab-widget {
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab-header {
        display: flex;
        align-items: center;
        width: 100%;
        height: 35px;
        margin-bottom: 5px;
      }

      .tabs-body {
        height: calc(100% - 40px);
        width: 100%;
        display: flex;
        justify-content: space-between;
        position: relative;

        &.noTab {
          height: 100%;
        }

        .table-loading-widget {
          position: absolute;
          left: 0px;
          top: 0px;
          bottom: 0px;
          right: 0px;
          background: #fff;
          z-index: 9999;
          border-radius: 5px;
        }

        .tab-content {
          height: 100%;
          width: calc(100% - 460px);
          background: #fff;
          padding: 0px 8px;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          position: relative;
          padding-top: 8px;

          .tab-container {
            overflow-y: auto;
            height: 100%;

            .table-data {
              border-collapse: collapse;
              border-spacing: 0;
              width: 100%;

              tr {
                &.row-data {
                  background: #fff;
                }

                &:hover {
                  background: rgb(248, 248, 248);
                  cursor: pointer;
                }

                th {
                  &.spacing {
                    padding: 10px 10px !important;
                  }

                  &.stick-title {
                    position: sticky;
                    top: 0px;
                    z-index: 999;

                    input {
                      position: relative;
                      top: 1px;
                      left: -2px;
                      margin-right: 5px;
                    }
                  }

                  &.center {
                    display: flex;
                    align-content: center;

                    input {
                      position: relative;
                      top: 0px;
                      margin-right: 5px;
                      margin: 0px 20px;
                    }
                  }

                  .force-start {
                    display: flex;
                    align-items: center;
                  }

                  &.text-center {
                    text-align: center;
                  }
                }

                td {
                  &.active {
                    background: #1ba5a523;
                  }

                  .editor {
                    padding: 10px 0px;
                  }

                  .options {
                    padding-bottom: 20px;
                  }

                  .checkbox {
                    position: relative;
                    top: -1px;
                    left: -2px;
                    margin-right: 10px;
                  }

                  &.spacing {
                    padding: 0px 10px;
                  }

                  .profile-content {
                    display: flex;
                    align-items: center;
                  }

                  .table-menu {
                    position: relative;
                  }

                  .center {
                    display: flex;
                    justify-content: center;
                  }

                  &:first-child {
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                  }

                  &:last-child {
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                  }

                  &.text-center {
                    text-align: center;
                  }

                  &.email {
                    color: #334d6eb0;
                    font-size: 12px;
                  }

                  .table-options {
                    display: flex;
                    align-items: center;
                  }
                }
              }
            }
          }

          &.outbox {
            width: 400px !important;
            display: flex;
            flex-direction: column;
            overflow-y: unset !important;
            padding: 0px !important;
            height: 100%;

            .outbox-section-header {
              height: 60px;
              display: flex;
              align-items: center;
              padding: 0px 18px;
              font-family: "Nunito";
              font-style: normal;
              font-weight: 600;
              font-size: 16px;
              color: #707070;
              border-bottom: 1px solid #dcdcdc;
            }

            .outbox-section-body {
              height: calc(100% - 60px);
              overflow-y: auto;

              .outbox-email-item {
                display: flex;
                margin-bottom: 15px;
                padding: 20px 18px;
                cursor: pointer;
                flex-direction: column;
                border: 1px solid transparent;
                box-shadow: 0px 2px 6px transparent;
                border-radius: 5px;

                &:hover {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                &.active {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                .outbox-user-profile {
                  display: flex;
                }

                .outbox-email-content {
                  width: 100%;

                  .email-subject {
                    font-size: 16px;
                    color: #1c1c1c;
                    margin-top: 6px;
                  }

                  .email-message {
                    font-size: 13px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    -webkit-line-clamp: 2;
                    line-height: 17px;
                    max-height: 4.4rem;
                    color: #8e8b8b;
                  }
                }
              }

              .email-signature-item {
                display: flex;
                flex-direction: column;
                padding: 16px 10px;
                border-radius: 10px;
                cursor: pointer;
                border: 1px solid transparent;
                box-shadow: 0px 2px 6px transparent;

                &:hover {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                &.active {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                .signature-header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .signature-title {
                    font-size: 17px;
                    font-weight: 600;
                    overflow: hidden;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }

                .signature-body {
                  color: #324552;
                }

                .signature-footer {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .signature-created-date {
                    color: #7d92a1;
                    font-size: 12px;
                  }

                  .default-status {
                    color: #0884af;
                  }
                }
              }
            }
          }
        }

        .tab-content-details {
          width: 450px;
          height: 100%;
          border-radius: 5px;
          background-color: #fff;
          display: flex;
          flex-direction: column;

          .tab-content-details-header {
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 15px;
            margin-bottom: 20px;
            margin-top: 20px;

            .tab-content-details-header-left-panel {
              .tab-content-details-title {
                font-size: 20px;
              }

              .tab-content-details-date {
                color: #707070;
              }
            }

            .tab-content-details-options {
              display: flex;
              align-items: center;
            }
          }

          .tab-content-details-body {
            height: calc(100% - 70px);
            overflow-y: auto;
            padding: 0px 15px;
            padding-bottom: 100px;

            .emaill-subject {
              font-size: 18px;
              margin-bottom: 20px;
            }

            p {
              margin: 0px;
              margin-bottom: 3px;
            }
          }

          &.outbox {
            width: calc(100% - 415px) !important;

            .tab-content-details-header {
              .tab-content-details-header-left-panel {
                .tab-content-details-title {}

                .tab-content-details-date {
                  margin-top: 10px;
                  color: #707070;
                }
              }
            }

            .tab-content-details-body {
              .email-message {
                background: #f7f7f7;
                border-radius: 10px;
                padding: 20px;
              }
            }
          }
        }
      }
    }
  }

  // Modals
  .overlay {
    .form-widget-modal {
      width: 850px;

      .moder-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .modal-body {
        width: 100%;

        .input-group {
          width: 100%;

          .question-widget {
            width: 100%;
            display: flex;
            flex-direction: column;

            .question-item {
              display: flex;
              align-items: center;
              width: 100%;
              margin-bottom: 20px;

              .question-form-widget {
                width: 100%;
                display: grid;
                grid-template-columns: calc(98% - 80px) 80px;
                grid-gap: 10px;

                .question-form {
                  padding: 6px;
                  background: #f0f0f0;
                  border-radius: 5px;

                  .section-label {
                    display: none;
                  }

                  &.section_widget {
                    position: relative;
                    margin-top: 30px;
                    border-left: 4px solid #28a5a5;

                    .section-label {
                      display: block;
                      position: absolute;
                      top: -28px;
                      background: #28a5a5;
                      color: #fff;
                      padding: 7px 21px;
                      left: -4px;
                      border-top-left-radius: 5px;
                      border-top-right-radius: 5px;
                    }
                  }

                  .question-header {
                    display: grid;
                    width: 100%;
                    grid-template-columns: calc(90% - 150px) 150px;
                    grid-gap: 9px;
                  }

                  .section-title-header {
                    width: 100%;

                    .input-form {
                      width: 100%;
                    }
                  }

                  .question-body {
                    padding: 10px 20px;

                    .title-section-widget-description {
                      width: 100%;
                    }

                    .solution-type {
                      &.short_answer {
                        padding: 8px 0px;
                        border-bottom: 1px dashed #ddd;
                        color: rgb(131, 131, 131);
                      }

                      &.paragraph_answer {
                        padding: 8px 0px;
                        border-bottom: 1px dashed #ddd;
                        color: rgb(131, 131, 131);
                      }

                      &.file_upload {
                        border: 1px dashed #ddd;
                        padding: 30px;
                        color: rgb(131, 131, 131);
                      }

                      &.date {
                        display: flex;
                        align-items: center;
                        border: 1px dashed #ddd;
                        width: 300px;
                        padding: 20px;

                        span {
                          margin-right: 10px;
                          color: rgb(131, 131, 131);
                        }
                      }

                      &.time {
                        display: flex;
                        align-items: center;
                        border: 1px dashed #ddd;
                        width: 300px;
                        padding: 20px;

                        span {
                          margin-right: 10px;
                          color: rgb(131, 131, 131);
                        }
                      }

                      &.choice_answer {
                        .choice-item {
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;

                          .choice-label {
                            background: #ddd;
                            border-radius: 5px;
                            padding: 10px 8px;
                            height: 40px;
                            width: 100%;
                            margin-left: 8px;
                          }

                          .btn-add {
                            margin-top: 15px;
                          }
                        }
                      }
                    }

                    .image-container {
                      display: flex;
                      flex-direction: column;
                      align-items: center;

                      .selected_image {
                        width: 100%;
                      }

                      .btn-reselect {
                        margin-top: 20px;
                        height: 40px;
                        width: 200px;
                        border: 1px solid#229EA5;
                        border-radius: 5px;
                        color: #229ea5;
                      }
                    }

                    .video-container {
                      display: flex;
                      flex-direction: column;
                      align-items: center;

                      .selected_video {
                        width: 100%;
                      }

                      .btn-reselect {
                        margin-top: 20px;
                        height: 40px;
                        width: 200px;
                        border: 1px solid#229EA5;
                        border-radius: 5px;
                        color: #229ea5;
                      }
                    }
                  }
                }

                .btn-remove {
                  height: 35px;
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                  border-radius: 5px;
                  margin-top: 6px;
                }

                .option {
                  background: #ffff;
                  padding: 5px;
                  width: 100px;
                  height: 211px;
                  border-radius: 5px;
                  display: flex;
                  flex-direction: column;

                  .btn-add {
                    color: #000;
                    display: flex;
                    align-items: center;
                    padding: 8px 10px;
                    width: 100%;
                    border-radius: 5px;

                    &:hover {
                      background: #f2f4f8;
                    }

                    img {
                      margin-right: 7px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .report-modal {
      width: 850px;
      background: #fff;
      min-height: 400px;
      border-radius: 5px;
      margin: 0 auto;
      padding: 15px 30px;

      .answer-report-title {
        font-size: 20px;
        margin-bottom: 30px;
      }

      .report-body {
        .report-item {
          .question-title {
            font-size: 16px;
          }

          &.checkbox {}

          .radio-report-widget {
            display: flex;
            width: 500px;

            .radion-item {
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;

              label {
                color: #fff;
              }
            }
          }

          .radio-report-legend {
            display: flex;
            margin-top: 10px;

            .legend-item {
              display: flex;
              align-items: center;
              margin-right: 20px;

              .legend-circle {
                height: 15px;
                width: 15px;
                border-radius: 50%;
                background: #1ba5a4;
                margin-right: 5px;
              }

              label {
                color: #1ba5a4;
              }
            }
          }
        }
      }

      .report-footer {
        padding: 20px 0px;
        margin-top: 30px;

        .btn-close {
          width: 220px;
          height: 47px;
          background: #0884af;
          border-radius: 5px;
          color: #fff;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.tab-content-details-body {
  p {
    margin: 0px;
  }
}
</style>
